import { FC, useContext, useEffect, useState } from 'react';

import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

import { AuthContext } from 'auth';
import { LocalizationContext } from 'localization';

import notification from '../../services/notificationService';
import { BookingModal } from '../BookingModal';
import { DepositModal } from '../DepositModal';

export const ModalsManager: FC = () => {
  const {
    data: { permissions },
  } = useContext(AuthContext);
  const { t } = useContext(LocalizationContext);
  const [isDepositModalOpen, setIsDepositModalOpen] = useState(false);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const keyboardListener = (event: KeyboardEvent): void => {
      if (!(event.altKey && event.ctrlKey)) return;

      switch (event.code) {
        case 'KeyD': {
          if (!permissions?.has('payment_create')) break;

          setIsDepositModalOpen(true);
          break;
        }
        case 'KeyB': {
          if (!permissions?.has('booking_manage')) break;

          setIsBookingModalOpen(true);
          break;
        }
        case 'KeyG': {
          if (!permissions?.has('payment_create')) {
            return notification.info({
              t,
              title: t('permission.error'),
              type: 'warning',
              dismiss: 5,
            });
          }
          navigate('/shop');
          break;
        }
      }
    };

    document.addEventListener('keydown', keyboardListener);

    return () => document.removeEventListener('keydown', keyboardListener);
  }, [setIsDepositModalOpen, permissions]);

  if (isDepositModalOpen) {
    return <DepositModal onClose={() => setIsDepositModalOpen(false)} />;
  }

  if (isBookingModalOpen) {
    return (
      <BookingModal
        selectedTime={dayjs().format('HH:mm')}
        onClose={() => setIsBookingModalOpen(false)}
      />
    );
  }

  return null;
};
